/**
 * 生日专区
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/birthday2',
    name: 'Birthday2',
    component: () => import('@/views/birthday/index.vue'),
    mate: {
      title: '熊猫生日',
      is_festivalPop: true
    }
  },
  {
    path: '/birthday',
    name: 'Birthday',
    component: () => import('@/views/birthday/entry.vue'),
    children: [
      {
        path: '',
        name: 'birthdayIndex',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/birthday/index.vue'
          ),
        meta: {
          title: '熊猫生日',
          is_festivalPop: true
        }
      },
      {
        path: '/birthday/brand_details',
        name: 'brandDetails',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/birthday/brandDetailds.vue'
          ),
        meta: {
          title: '品牌详情'
        }
      },
      {
        // 适用门店（对齐 h5 /center/brandDetial：城市 tab + 区域分组）
        path: '/birthday/store_list',
        name: 'birthdayStoreList',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/birthday/storeList.vue'
          ),
        meta: {
          title: '适用门店'
        }
      },
      {
        path: '/birthday/list',
        name: 'brandList',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/birthday/list.vue'
          ),
        meta: {
          title: '商品列表'
        }
      },
      {
        path: '/birthday/brandClassify',
        name: 'brandClassify',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/birthday/brandClassify.vue'
          ),
        meta: {
          title: '全部品牌'
        }
      }
    ]
  }
];
